import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FBWhite, FbLogoPNG, LPLogoWName, Logo1024PNG, Selfie, Selfie2 } from "../../assets/index";
import SignupForm from "@Components/SignupForm";
import styles from "./styles";
import { RootState, useAppDispatch, useAppSelector } from "@Store/store";
import { ROUTES } from "@Constants/routes";
import { displayToast } from "@Utils/toast";
import { CheckPasswordStrength, getReferralIdFromCookie, getUtmParamsFromCookies } from "@Utils/common";
import { parsePhoneNumber } from "react-phone-number-input";
import { useResendOtpMutation, useVerifyOtpMutation } from "@Components/SignupForm/signupSlice";
import OTPInput from "react-otp-input";

const OtpVerification = () => {


  useEffect(() => {
    document.title = "LinkPlease - Email Verification";
  }, []);

  const navigate = useNavigate();

  // const notify = () => toast.error("Wow so easy !", { theme: 'colored'});
  const { user } = useAppSelector((state: RootState) => state.profile);

  const [otp, setOtp] = useState<string>("");

  const [timeLeft, setTimeLeft] = useState(15);
  const [canResend, setCanResend] = useState(false);



  const [verifyOtp, { data: verifyOtpData, error: verifyOtpErr }] = useVerifyOtpMutation();
  const [resendOtp, { data: resendOtpData, error: resendOtpError }] = useResendOtpMutation();

  useEffect(() => {
    if (timeLeft > 0) {
      const timer = setTimeout(() => {
        setTimeLeft(timeLeft - 1);
      }, 1000);

      return () => clearTimeout(timer);
    } else {
      setCanResend(true);
    }
  }, [timeLeft]);


  const onResendOTPClick = (e: any) => {
    e.preventDefault()
    resendOtp({ email: user?.email })
  }

  useEffect(() => {
    if (resendOtpData) {
      displayToast("success", resendOtpData?.message);
      setTimeLeft(15)
    }

    if (verifyOtpErr) {
      displayToast("error", resendOtpError?.message);
    }
  }, [resendOtpData, resendOtpError])



  const handleOtp = (e: any) => {
    e.preventDefault();
    console.log(otp)
    if(otp.length!=6) {
      displayToast('error', 'Invalid OTP')
      return;
    }
    verifyOtp({ otp });
  };


  useEffect(() => {
    if (verifyOtpData?.status) {
      displayToast("success", "Email Verified Successfully");
      navigate(ROUTES.IG_CONNECT, {replace:true});
    }

    if (verifyOtpErr) {
      // setShowError(parseErrorMessage(verifyErr));
      displayToast("error", verifyOtpErr?.data?.message);
    }
  }, [verifyOtpData, verifyOtpErr]);




  return (
    <div style={styles.SIGNUP_CONTAINER} className="min-h-screen w-full flex items-center justify-center"
    >
      <div className="max-w-[500px] flex flex-col items-center bg-white p-4 rounded-2xl" style={styles.SIGNUP_CONTAINER}>
        <div className="mb-8">
          <img src={LPLogoWName} className="w-[250px]" alt="Linkplease Logo" />
        </div>

        <div className="text-center mb-4">
          <h1 className="text-[1.2rem] font-semibold">Hey👋, Lets make you viral🚀 </h1>
          {/* <h1 className="text-[1.2rem] font-semibold">Start Your Journey! 🚀</h1> */}
        </div>

        <div className="w-full">
          <>
            <div className="text-center mb-6">
              <h2 className="text-[1.2rem] font-semibold mb-2">
                Verify Email
              </h2>
              <p className="text-[#787781] text-sm">
                Email is sent on <span className="text-[#7772FF]">{user?.email}</span>
              </p>
              <p className="text-[#787781] text-sm mt-1">(Check your spam if you haven't received)</p>
            </div>
            <form className="w-full space-y-4">
              <div className="flex justify-center items-center gap-2">
                <OTPInput
                  value={otp}
                  onChange={setOtp}
                  numInputs={6}
                  renderSeparator={<span className="mx-1"></span>}
                  inputStyle={{ width: '40px', height: '40px' }}
                  renderInput={(props) => (
                    <input
                      {...props}
                      className="text-center border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#7772FF] focus:border-transparent"
                    />
                  )}
                />
              </div>
              <button
                className="w-full bg-[#7772FF] text-white py-3 rounded-lg font-medium hover:bg-[#6561FF] transition-colors disabled:opacity-50"
                onClick={handleOtp}
              >
                Verify
              </button>
              <div className="text-center">
                <button
                  className={`text-sm ${timeLeft ? 'text-[#787781]' : 'text-[#7772FF] hover:underline'}`}
                  disabled={timeLeft > 0}
                  onClick={onResendOTPClick}
                >
                  Resend OTP {timeLeft ? `(${timeLeft})` : ''}
                </button>
              </div>
            </form>
          </>
        </div>
        <div className="mt-6 text-center">
          <p className="text-[#787781] text-sm">
            Already have an account?{" "}
            <span
              className="text-[#7772FF] hover:cursor-pointer hover:underline"
              onClick={() => navigate("/login")}
            >
              Login
            </span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default OtpVerification;
